import { onPath } from '../utils/path';
import { selectOne, getWindow } from '../utils/dom-utils';

onPath('/affiliates', () => {
  const win = getWindow();
  const formWrapper = selectOne('#js-affiliates-form-wrapper');

  const libScript = document.createElement('script');
  libScript.setAttribute('id', 'hubspot-forms-script')
  libScript.setAttribute('type', 'text/javascript');
  libScript.setAttribute('src', '//js.hsforms.net/forms/v2.js');

  win.document.body.appendChild(libScript);

  libScript.addEventListener('load', () => {
    win.hbspt.forms.create({
      portalId: '543330',
      formId: 'c2a804fb-470c-4495-b1a4-7ba0db38f37c',
      target: '#js-affiliates-form-wrapper'
    });
  });
});

